
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Redirect from feedwise-exchange.lovable.app to feedmyback.com
if (window.location.hostname === 'feedwise-exchange.lovable.app') {
  const newUrl = 'https://feedmyback.com' + window.location.pathname + window.location.search;
  window.location.href = newUrl;
}

// Force clear browser cache when new version is loaded
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    for (const registration of registrations) {
      registration.unregister();
    }
  });
  
  // Clear site cache
  if (window.caches) {
    caches.keys().then(keyList => {
      return Promise.all(keyList.map(key => caches.delete(key)));
    });
  }
}

// Add timestamp to help debug cache issues
const BUILD_TIMESTAMP = new Date().toISOString();
console.log('Application initializing. Build timestamp:', BUILD_TIMESTAMP);

// Store version information in localStorage for reference
localStorage.setItem('app_version', BUILD_TIMESTAMP);

// Add clear cache listener
window.addEventListener('load', () => {
  // Check if we should clear cache (add ?force_reload=true to URL)
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('force_reload') === 'true') {
    console.log('Forcing reload due to URL parameter');
    
    // Clear caches if available
    if (window.caches) {
      caches.keys().then(keyList => {
        return Promise.all(keyList.map(key => caches.delete(key)));
      });
    }
    
    // Remove the parameter from URL
    urlParams.delete('force_reload');
    window.history.replaceState({}, document.title, 
      window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : ''));
  }
});

// Ensure we're properly creating the root and rendering the app
const root = document.getElementById('root');
if (!root) {
  console.error('Root element not found! App cannot render.');
} else {
  const reactRoot = ReactDOM.createRoot(root);
  reactRoot.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
